import logo from "../../../../assets/VZY/vzy-logo.svg";

export const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="copyright-logo">
              <img src={logo} alt="VZY Logo" />
              <p>© {new Date().getFullYear()} VZY. All Rights Reserved.</p>
            </div>
          </div>

          <div className="col-md-8">
            <ul>
              <li>
                <a
                  href="https://www.vzy.one/en/supportPage/privacyPolicy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </li>

              <li>
                <a
                  href="https://www.vzy.one/en/supportPage/termsOfUse"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms & Conditions
                </a>
              </li>

              <li>
                <a
                  href="https://www.vzy.one/en/supportPage/cookiePolicy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cookies
                </a>
              </li>

              <li>
                <a
                  href="https://www.vzy.one/en/supportPage/aboutUs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  About Us
                </a>
              </li>

              <li>
                <a
                  href="https://www.vzy.one/en/supportPage/grievance"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Grievance
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};
